import { connect } from 'react-redux';

const withUserData = connect(state => ({ user: state.user }));

export default withUserData;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/enhancers/withUserData.js
 **/